import { Button, Form, FormGroup, Input } from '@/platform/ui';
import { useForm, usePage } from '@inertiajs/react';
import { useEffect } from 'react';

const PersonalInformationForm = () => {
    const { user } = usePage().props;
    const { data, setData, errors, put, processing } = useForm({});

    useEffect(() => {
        setData({
            ...(user || {}),
        });
    }, [user]);

    const handleSubmit = () => {
        put('/user/profile-information', {
            preserveScroll: true,
        });
    };

    return (
        <Form onSubmit={handleSubmit}>
            <FormGroup inline equal>
                <Input
                    label='Voornaam'
                    required
                    value={data?.first_name || ''}
                    onChange={event =>
                        setData('first_name', event.target.value)
                    }
                    error={errors?.first_name}
                />
                <Input
                    label='Tussenvoegsel'
                    value={data?.affix || ''}
                    onChange={event => setData('affix', event.target.value)}
                    error={errors?.affix}
                />
                <Input
                    label='Achternaam'
                    required
                    value={data?.last_name || ''}
                    onChange={event => setData('last_name', event.target.value)}
                    error={errors?.last_name}
                />
            </FormGroup>
            <FormGroup inline equal>
                <Input
                    label='E-mailadres'
                    required
                    type='email'
                    value={data?.email || ''}
                    disabled
                    onChange={event => setData('email', event.target.value)}
                    error={errors?.email}
                />
                <Input
                    label='Telefoonnummer'
                    value={data?.telephone_number || ''}
                    onChange={event =>
                        setData('telephone_number', event.target.value)
                    }
                    error={errors?.telephone_number}
                />
            </FormGroup>
            <div className='mt-4 flex items-center justify-end'>
                <Button type='submit' variant='primary' loading={processing}>
                    Opslaan
                </Button>
            </div>
        </Form>
    );
};

export default PersonalInformationForm;
